import {isMobileScreenWidth} from '@Hooks/useIsMobileWidth';
import {renderElement, unmountAndRemoveElement} from '@Utils/root-element.util';
import {openActionablePopupModal} from '@Modals/actionable-popup-modal/actionable-popup-modal.library';
import type {ActionablePopupProps} from '@Components/actionable-popup/actionable-popup.types';
import {ActionablePopup} from '@Components/actionable-popup/actionable-popup';

const ACTIONABLE_POPUP_CONTAINER_CLASS = 'pmw-actionable-popup-container';

export const showActionablePopup = ({ctaButton, onClose, ...opts}: ActionablePopupProps): void => {
  if (isMobileScreenWidth(window.innerWidth)) {
    openActionablePopupModal({ctaButton, onClose, ...opts});
    return;
  }

  const existingPopup = document.body.querySelector(`.${ACTIONABLE_POPUP_CONTAINER_CLASS}`);
  if (existingPopup instanceof HTMLElement) {
    unmountAndRemoveElement(existingPopup);
  }

  const container = document.createElement('div');
  container.classList.add(ACTIONABLE_POPUP_CONTAINER_CLASS);
  container.classList.add('_position-fixed');
  container.classList.add('_z-index-max');

  const teardown = (): void => {
    unmountAndRemoveElement(container);
  };

  renderElement(
    container,
    <ActionablePopup
      {...opts}
      ctaButton={{
        ...ctaButton,
        onClick: (): void => {
          ctaButton.onClick();
          teardown();
        },
      }}
      onClose={(): void => {
        onClose();
        teardown();
      }}
    />
  );

  document.body.appendChild(container);
};
